var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('time-unit-input',{attrs:{"setup":{
      'func': _vm.setOffset,
      'args': {
        'model': _vm.delay,
        'key': 'offset',
        'prefix': 'delay_',
      }
    }}}),_c('switch-input',{attrs:{"setup":{
      'func': _vm.setLimit,
      'args': {
        'model': _vm.context,
        'key': 'limit',
        'prefix': 'delay_',
      }
    }}}),_c('delay-limit',{attrs:{"delay":_vm.delay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }